import { upperFirst } from "lodash"
import { ChangeEventHandler } from "react"
import { Controller, UseFormReturn } from "react-hook-form"

import {
  FormInput,
  InnerLabel,
  InputError,
  InputWrapper,
  OpenSelect,
  SelectWrapper,
} from "../styles/FormElementStyles"

export interface SelectMenuProps {
  id: string
  name: string
  values?: any
  disabled?: boolean
  defaultValue?: any
  handleSelect?: (name: string, value: string) => void
  error?: any
  label?: string | JSX.Element
  showLabel?: boolean
  required?: boolean
  formHook: UseFormReturn<any>
}

const SelectMenu = ({
  id,
  name,
  values,
  disabled,
  error,
  label,
  required,
  formHook,
  handleSelect = () => {},
  defaultValue = null,
  showLabel = !!defaultValue,
}: SelectMenuProps) => {
  const { control } = formHook
  const updateSelect: ChangeEventHandler<HTMLSelectElement> = (event) => {
    handleSelect(name, event.target.value)

    return event
  }

  return (
    <FormInput>
      <InputWrapper $error={error}>
        <SelectWrapper $showLabel={showLabel}>
          <OpenSelect>▼</OpenSelect>
          {control && (
            <Controller
              name={name}
              control={control}
              defaultValue={defaultValue}
              rules={{ required }}
              render={({ field }) => {
                return (
                  <select
                    id={id}
                    onChange={updateSelect}
                    value={field.value}
                    disabled={disabled}
                  >
                    {defaultValue === null && (
                      <option className="placeholder" value="null">
                        Select {field.name}
                      </option>
                    )}
                    {values.map((value) => (
                      <option value={value} key={`${field.name}-${value}`}>
                        {value}
                      </option>
                    ))}
                  </select>
                )
              }}
            />
          )}
        </SelectWrapper>
        <InnerLabel htmlFor={id} $showLabel={showLabel}>
          {label}
        </InnerLabel>
      </InputWrapper>
      {error && (
        <InputError>{upperFirst(error.message || error.type)}</InputError>
      )}
    </FormInput>
  )
}

export default SelectMenu
